/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-trigger.js
 *
 * 指定クラスの位置までスクロールして,実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { setCreateSpan } from "../setCreateSpan";

setCreateSpan()

//定義
let speed = 0.7;
const Trigger = document.querySelectorAll(".trigger");
const Fadein = document.querySelectorAll(".fadein");
const FadeinTrain = document.querySelectorAll(".fadein__train");
const SlideLeft = document.querySelectorAll(".slide__left");
const SlideUpTrain = document.querySelectorAll(".slide__up__train");
const Shutter = document.querySelectorAll(".shutter");
const ShutterDown = document.querySelectorAll(".shutter__create");

//シャッター要素生成
for (let i = 0; i < Shutter.length; i++) {
  let createShutter = document.createElement("span");
  createShutter.className = "shutter__create";
  Shutter[i].appendChild(createShutter);
}

/**
 * set
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
gsap.set([Fadein], {
  opacity: 0,
});
gsap.set([FadeinTrain], {
  opacity: 0,
});
gsap.set([SlideUpTrain], {
  yPercent: 50,
});
gsap.set([SlideLeft], {
  xPercent: 50,
});
gsap.set([ShutterDown], {
  scaleY: 1
});

/**
 * Trigger
 * 指定クラスの位置までスクロールして,実行する
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setTrigger = () => {
  for (let i = 0; i < Trigger.length; i++) {
    gsap.to(Trigger[i].querySelectorAll(".fadein"), {
      opacity: 1,
      duration: speed,
      scrollTrigger: {
        trigger: Trigger[i],
        start: "top 75%",
        //   markers: true,
      },
    });
    gsap.to(Trigger[i].querySelectorAll(".fadein__train"), {
      opacity: 1,
      duration: speed,
      scrollTrigger: {
        trigger: Trigger[i],
        start: "top 75%",
        //   markers: true,
      },
      stagger: {
        from: "start",
        amount: 0.7
      }
    });
    gsap.to(Trigger[i].querySelectorAll(".slide__up__train"), {
      yPercent: 0,
      duration: speed,
      scrollTrigger: {
        trigger: Trigger[i],
        start: "top 75%",
        //   markers: true,
      },
      stagger: {
        from: "start",
        amount: 0.7
      }
    });
    gsap.to(Trigger[i].querySelectorAll(".slide__left"), {
      xPercent: 0,
      duration: speed,
      scrollTrigger: {
        trigger: Trigger[i],
        start: "top 75%",
        //   markers: true,
      },
    });
    gsap.to(Trigger[i].querySelectorAll(".shutter__create"), {
      scaleY: 0,
      duration: speed,
      delay: 0.5,
      scrollTrigger: {
        trigger: Trigger[i],
        start: "top 75%",
        // markers: true,
      },
    });
  }
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setTrigger };
